import {TableNode} from '@table-library/react-table-library'
import {MutableRefObject, ReactNode, createContext, useContext} from 'react'
import {DataTableCallbacksRefData} from './hooks/use-callbacks-ref'
import {DataTableSelectContext} from './hooks/use-row-select'
import {DataTableColumnInfo} from './model'

export interface DataTableContextInfo {
  data: Array<TableNode>
  allColumns: Array<DataTableColumnInfo<string, TableNode>>,
  select?: DataTableSelectContext,
  searchValue: string,
  setSearchValue: (v: string) => void,
}

const DataTableContext = createContext({} as DataTableContextInfo)

interface DataTableContextProviderProps {
  value: DataTableContextInfo,
  children: Array<ReactNode>|ReactNode,
}

export function DataTableContextProvider({
  value,
  children,
}: DataTableContextProviderProps) {
  // @ts-ignore
  return <DataTableContext.Provider value={value}>{children}</DataTableContext.Provider>
}

export function useDataTableContext() {
  return useContext(DataTableContext)
}


export interface DataTableRefsContextInfo {
  callbacksRef: MutableRefObject<DataTableCallbacksRefData>,
}

export const DataTableRefsContext = createContext({} as DataTableRefsContextInfo)

export function useDataTableRefsContext(): DataTableRefsContextInfo {
  return useContext(DataTableRefsContext)
}


